import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="gtm-checkout"
export default class extends Controller {
  static values = {
    cartData: Object
  }

  // Trigger when checkout button is clicked
  trackCheckout(event) {
    const cartData = this.cartDataValue
    
    if (!cartData || !cartData.items || cartData.items.length === 0) {
      return
    }

    // Transform cart items to GA4 format
    const items = cartData.items.map(item => ({
      item_id: item.sku || item.id,
      item_name: item.name,
      item_category: item.category,
      price: parseFloat(item.price),
      quantity: parseInt(item.quantity)
    }))

    // Push to GTM dataLayer
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: "begin_checkout",
        ecommerce: {
          currency: "USD",
          value: parseFloat(cartData.total || 0),
          items: items
        }
      })
    }
  }
}
